import { useAtomValue } from 'jotai';
import { Navigate, Outlet } from 'react-router';
import { isAuthenticatedAtom } from '@/stores/auth.store';

export function ProtectedRoute() {
  const isAuthenticated = useAtomValue(isAuthenticatedAtom);
  if (!isAuthenticated) return <Navigate to='/login' replace />;
  return <Outlet />;
}
